import { useEffect, useState } from 'react'
import { Button, Modal, Spin, Select } from 'antd'
import { connect } from 'react-redux'
import { Save, X } from 'react-feather'
import { useSpreadSheetData } from './SpreadSheetDataProvider'
import { useEditsHelpers } from './EditsHelpersProvider'
import { useHelpers } from './SpreadSheetHelpersProvider'
import { setTableConfig } from 'Actions/explore'

SaveChangesModal = ({ width, isClosing, closeTab, type, setIsDirty, label }) ->

  [{
    edits,
    rowsToBeDeleted
  }, dispatch] = useSpreadSheetData()

  { isModalVisible, setIsModalVisible } = useHelpers()
  { discardChanges, saveChanges } = useEditsHelpers()
  [isSaving, setIsSaving] = useState(false)
  [hasUnsavedChanges, setHasUnsavedChanges] = useState(false)

  useEffect( ->
    edits = _.values(edits).find((row) ->
      _.values(row).find((cell) -> cell?)?
    ) or _.values(rowsToBeDeleted).find((r) -> r?)
    setHasUnsavedChanges(!!edits)
    setIsDirty(!!edits)
    undefined
  , [edits, rowsToBeDeleted])

  onClose = () ->
    if hasUnsavedChanges
      setIsModalVisible(true)
    else
      closeTab(type)

  useEffect( ->
    if isClosing
      onClose()
    undefined
  , [isClosing])

  <Modal
    centered
    onCancel={ -> setIsModalVisible(false)}
    visible={isClosing or isModalVisible}
    mask={false}
    footer={
      <div style={{ textAlign: 'right' }}>
        <Button
          danger
          style={{ margin: 5, float: 'left' }}
          onClick={ ->
            setIsModalVisible(false)
            discardChanges()
            closeTab(type)
          }
        >Discard</Button>
        <Button
          style={{ margin: 5 }}
          onClick={ -> setIsModalVisible(false)}>
          Cancel
        </Button>
        <Button
          style={{ margin: 5 }}
          type="primary"
          data-testid="save-changes-btn"
          onClick={ ->
            setIsModalVisible(false)
            setIsSaving(true)
            await saveChanges()
            setIsSaving(false)
            closeTab(type)
          }
        >Save</Button>
      </div>
    }
  >You have unsaved changes in { label }. Do you wish to save them before closing?</Modal>

export default SaveChangesModal
